import { render, staticRenderFns } from "./NumberTextBuilder.vue?vue&type=template&id=013ec2a8&scoped=true"
import script from "./NumberTextBuilder.vue?vue&type=script&lang=js"
export * from "./NumberTextBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ec2a8",
  null
  
)

export default component.exports